import React, { useEffect, useState } from "react";

export const useTimer: () => [number, () => void, () => void] = () => {
	const [time, setTime] = useState(0)
    const [enabled, setEnabled] = useState(false)

	useEffect(() => {
		let interval: NodeJS.Timeout | null = null
		if (enabled) {
			interval = setInterval(() => {
				setTime(time => time + 1);
			}, 1000);
		} else if (!enabled && time !== 0) {
			if (interval) {
				clearInterval(interval)
			}
		}
		if (interval) {
			return () => clearInterval(interval!);
		}
	}, [enabled, time])

    const start = () => {
        setEnabled(true)
        setTime(0)
    }

    const stop = () => {
        setEnabled(false)
    }

	return [time, start, stop]
}